module.exports = __webpack_public_path__ + "img/2010-4.a6a4d8de.jpg";